import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import useTextContents from 'common/hooks/useTextContents'
import { AppLinks } from 'enviroment/AppLinks'
import { ChooseIdentityMethodTypes, IChooseIdentityMethodPageProps } from 'pages/ChooseIdentityMethodPage/ChooseIdentityMethodPageProps'
import Summary from 'components/Summary/Summary'
import ButtonCancelApplication from 'components/Buttons/ButtonCancelApplication/ButtonCancelApplication'
import Button, { AppButtonTypes } from 'components/Buttons/ButtonBase/Button'
import useIsMobile from 'common/hooks/useIsMobile'
import analyticsService from 'service/AnalyticsService/AnalyticsService'
import { AppState } from 'store'

import './VideoVerificationErrorPageStyles.scss'

/**
 * Komponent obsługujący stronę błędu aplikacji dla wideo weryfikacji
*/
const VideoVerificationErrorPage = (props: IChooseIdentityMethodPageProps): JSX.Element => {
   const isIdentityPage = Boolean(props.chooseIdentityMethodType === ChooseIdentityMethodTypes.IDENTITY)
   const isMobileDevice = useIsMobile()
   const navigate = useNavigate()
   const analyticsEventTypesNames = useSelector((state: AppState) => state.globalConfigurationState.analyticsEventTypesNames)

   const videoVerificationErrorPageTextContents = useTextContents()

   useEffect(() => {
      const failedEventTypeName = analyticsEventTypesNames?.IdentificationVideoVerificationFailed

      if(isIdentityPage && failedEventTypeName) {
         analyticsService
            .createSingleAnalyticEvent(failedEventTypeName)
            .catch(error => console.warn('Nie udało się zapisać eventu błędu wideoweryfikacji.', error))
      }
   }, [analyticsEventTypesNames?.IdentificationVideoVerificationFailed, isIdentityPage])

   const handleChooseAnotherVerificationMethod = () => {
      navigate(isIdentityPage? AppLinks.chooseIdentityMethod : AppLinks.chooseVerificationMethod)
   }


   // useEffect(() => {
   //    sessionStorage.add(STORAGEKEYS.IS_VIDEO_VERIFICATION_DISABLED, 'true')
   // }, [])


   return (
      <div className='video-verification-error-page-main-wrapper'>
         <section className='video-verification-error-page-outer-section-wrapper'>
            <div className='video-verification-error-page-heading-wrapper'>
               <h1>{videoVerificationErrorPageTextContents(isIdentityPage? 'videoVerificationErrorPage.identity.heading' : 'videoVerificationErrorPage.verification.heading')}</h1>
               <p>{videoVerificationErrorPageTextContents(isIdentityPage? 'videoVerificationErrorPage.identity.content' : 'videoVerificationErrorPage.verification.content')}</p>
            </div>
            <Button
               uiButtonType={AppButtonTypes.PRIMARY} 
               buttonContent={videoVerificationErrorPageTextContents('buttons.videoVerificationChooseVerificationProcess')} 
               className='video-verification-error-page-submit-button page-main-button-submission-button' 
               onClick={handleChooseAnotherVerificationMethod}
            />
            <ButtonCancelApplication />
         </section>
         {!isMobileDevice && <Summary isExtended={true} />}
      </div>
   )
}

export default VideoVerificationErrorPage
